import { Request } from "../../request";
import { getURL } from "../../utils";

export const get_company_drivers = (
  province_id,
  city_id,
  first_name,
  last_name,
  username
) => {
  return new Promise((resolve, reject) => {
    resolve({
      code: 200,
      success: true,
      message: "",
      pagination: {
        count: 10,
        pages: 1,
        page: 1,
        limit: 10,
        next: null,
        next_url: null,
        previous: null,
        previous_url: null,
      },
      data: [
        {
          pk: 14,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 1366811,
            fullname: "ایمان محمدی",
            phone_number: "",
            national_id: null,
          },
          created_at: "1401-10-11",
          plate_number: "74ع54358",
        },
        {
          pk: 13,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027683,
            fullname: "امید توکلی",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401-10-11",
          plate_number: "74ع44243",
        },
        {
          pk: 12,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027675,
            fullname: "حسن درخشان",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/10",
          plate_number: "21ع54155",
        },
        {
          pk: 11,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027682,
            fullname: "آرش دهقانی",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "73ع55955",
        },
        {
          pk: 9,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027681,
            fullname: "امیر دادوی",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "73ع54155",
        },
        {
          pk: 6,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027680,
            fullname: "حامد موسی خانی",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "56ع99244",
        },
        {
          pk: 5,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027679,
            fullname: "سید سهراب صالحی",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "21ع54155",
        },
        {
          pk: 3,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 2027678,
            fullname: "ابراهیم هنرمند",
            phone_number: "09332683286",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "75و19222",
        },
        {
          pk: 2,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 934019,
            fullname: "مصطفی رحمانی",
            phone_number: "",
            national_id: null,
          },
          created_at: "1401/10/12",
          plate_number: "13م71322",
        },
        {
          pk: 1,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 296202,
            fullname: "مهدی ابدال",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "99م71522",
        },
        {
          pk: 1,
          is_active: true,
          city: "اصفهان",
          province: "اصفهان",
          user: {
            id: 296202,
            fullname: "محمدرضا سلیمانی راد",
            phone_number: "",
            national_id: "",
          },
          created_at: "1401/10/12",
          plate_number: "385م91",
        },
      ],
      extra: {},
      meta: {
        site: "helix",
        site_id: 4,
        version: "1.3.8\n",
        app_version: "0.0.0",
      },
    });
  });
};

export const post_company_drivers = (data) => {
  return Request.post(getURL("/api/corporation-pa/accounts/set-company-driver/"), data);
};

export const put_company_drivers = (data) => {
  return Request.put(getURL("/api/corporation-pa/accounts/set-company-driver/"), data);
};
